import { makeStyles } from '@material-ui/core/styles'

import castle from '../assets/bannerERoom.png'

export const escapeRoomStyles = makeStyles(() => ({
    banner: {
        backgroundImage: `linear-gradient(rgba(0,0,0,0.5),rgba(0,0,0,0.5)), url(${castle})`,
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'cover',
        width: 600,
        height: 150,
        display: 'flex',
        justifyContent: 'space-between',
        flexDirection: 'column',
    },
    divTittle: {
        display: 'flex',
        justifyContent: 'space-between',
        marginTop: '-25px'
    },
    contentText: {
        color: 'white',
        textAlign: 'justify',
        padding: 30
    },
    dialog: {
        backdropFilter: 'blur(3px)',
        backgroundColor: 'rgba(0,0,30,0.4)'
    },
    dialogContent: {
        padding: '20px 0px'
    },
    ul: {
        padding: 0,
        margin: 0
    },
    listItem: {
        listStyle: 'none',
        padding: 15,
        color: 'white',
        maxWidth: '33%'
    },
    bannerDiv: {
        minHeight: 300,
        minWidth: 800,
        backgroundColor: 'black',
        borderRadius: 20,
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center'
    },
    directionsDiv: {
        minHeight: 400,
        minWidth: 800,
        backgroundColor: 'black',
        borderRadius: 20,
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'flex-start',
        alignItems: 'stretch',
        marginBottom: 40
    },
    wrapImageDescription: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center'
    },
    imageDescription: {
        display: 'flex',
        justifyContent: 'center',
        width: 500,
        height: 200
    },
    fullDescription: {
        display: 'flex',
        flexDirection: 'column'
    },
    totalTimeWrap: {
        color: 'white',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        padding: 30,
        flexDirection: 'row'
    },
    scrollViewPaper: {
        maxHeight: '100%',
        overflow: 'auto',
        backgroundColor: '#161616',
        margin: '10px 20px'
    },
    scrollViewList: {
        display: 'flex',
        flexDirection: 'row',
        backgroundColor: '#161616'
    },
    infoTimeCard: {
        padding: 10,
        color: 'white',
        textAlign: 'center',
        display: 'flex',
        justifyContent: 'flex-start',
        alignItems: 'center',
        fontSize: 12
    },
    smallCardInfo: {
        padding: 10,
        color: 'white',
        textAlign: 'center',
        display: 'flex',
        justifyContent: 'flex-start',
        alignItems: 'center',
        fontSize: 12
    }

}))
